//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const OpenSearchLookupGetOrSetOnce: FeatureFlag = {"Id":"OpenSearchLookupGetOrSetOnce","Label":"(KILL)[10.24]OpenSearchLookupGetOrSetOnce","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. Coalesce concurrent OpenSearch datasource lookup cache misses through GetOrSetOnceAsync instead of allowing each miss to fetch independently.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
